import React, { useEffect, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import Tag from 'sushiweb/Tag';

import { orderModel } from '../../../../api';
import { Modal, Table } from '../../../../UiKit';

export function OrdersInSameCart({ cartId }) {
  const [isVisible, setIsVisible] = useState(false);

  if (!cartId) return null;

  return (
    <>
      <p className='colorGreen' onClick={() => setIsVisible(true)}>
        View Linked Orders
      </p>

      {isVisible && (
        <OrdersInSameCartModal
          isVisible={isVisible}
          handleClose={() => setIsVisible(false)}
          cartId={cartId}
        />
      )}
    </>
  );
}

function OrdersInSameCartModal({ isVisible, handleClose, cartId }) {
  if (!isVisible) return null;

  return (
    <>
      <Modal
        isVisible={isVisible}
        type='large'
        title='Linked Orders'
        handleClose={handleClose}
        component={<OrdersInSameCartContainer cartId={cartId} />}
      />
    </>
  );
}

const getTableData = (details) => {
  const tableData = {
    headings: tableHeadings,
    rows: getTableRows(details),
  };
  return tableData;
};

const tableHeadings = [
  { name: 'Order ID', key: 1 },
  { name: 'Delivery Status', key: 2 },
  { name: 'type', key: 3 },
  { name: 'tags', key: 4 },
];

const getTableRows = (details) => {
  const rowsData = [];
  details &&
    details.map((item) => {
      const rowObj = {
        1: {
          title: item.order_id ? (
            <div
              role='button'
              tabIndex={0}
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                window.open(
                  `/lifeline?type=order_id&value=${item.order_id}`,
                  '_blank',
                );
                return;
              }}
            >
              {item.order_id || '-'}
            </div>
          ) : (
            '-'
          ),
        },
        2: {
          title: item.delivery_status.text ? (
            <div
              style={{
                background: item.delivery_status.bg_color,
                color: item.delivery_status.color,
                padding: '2px 4px',
                borderRadius: '5px',
              }}
            >
              {item.delivery_status.text}
            </div>
          ) : (
            '-'
          ),
        },
        3: {
          title: item.type_tag.text ? (
            <div
              style={{
                background: item.type_tag.bg_color,
                color: item.type_tag.color,
                padding: '2px 4px',
                borderRadius: '5px',
              }}
            >
              {item.type_tag.text}
            </div>
          ) : (
            '-'
          ),
        },
        4: {
          title: item?.tags?.length ? (
            <div
              css={`
                display: flex;
                gap: 0.5rem;
                flex-wrap: wrap;
              `}
            >
              {item.tags.map((tag) => (
                <Tag
                  type='tag'
                  label={tag.title}
                  bgColor={tag.type === 'SYSTEM' ? '#F6F9FD' : '#F8F8F8'}
                  textColor={tag.type === 'SYSTEM' ? '#0366D6' : '#828282'}
                  padding={0}
                />
              ))}
            </div>
          ) : (
            '-'
          ),
        },
      };
      rowsData.push(rowObj);
      return true;
    });
  return rowsData;
};

function OrdersInSameCartContainer({ cartId }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noOtherOrders, setNoOtherOrders] = useState(false);

  useEffect(() => {
    if (!cartId) return;

    setLoading(true);
    orderModel
      .getOrdersFromCartId(cartId)
      .then((res) => {
        if (res?.orders?.length > 0) {
          setOrders(res.orders);
        } else {
          setNoOtherOrders(true);
        }
      })
      .catch((e) => {
        throw new Error(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [cartId]);

  if (!cartId) return null;

  if (noOtherOrders) return <h2>No other orders for the cart id: {cartId}</h2>;

  return (
    <>
      {loading ? <Shimmer height='200px' width='700px' /> : null}
      {orders.length ? <Table tableData={getTableData(orders)} /> : null}
    </>
  );
}

export { OrdersInSameCartModal };
